import clsx from 'clsx';
import { Typography } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import UnifiedButton from 'shared/studio/UnifiedButton/UnifiedButton';
import { UnifiedButtonType } from 'shared/studio/UnifiedButton/UnifiedButton.types';
import { HeroHalfTest } from 'types/studio/studio';
import Badges from '../Badges/Badges';
import HeroHalfTestHeadlineAndSubtitle from '../HeroHalfTestHeadlineAndSubtitle/HeroHalfTestHeadlineAndSubtitle';
import styles from './HeroHalfTestContent.module.scss';

type Props = { sectionType: string; visibleOnPageLoad: boolean } & Pick<
  HeroHalfTest,
  | 'contentPosition'
  | 'unifiedButton'
  | 'unifiedButton2'
  | 'headline'
  | 'text'
  | 'caption'
  | 'captionIcon'
  | 'ratingTitle'
  | 'ratingValue'
  | 'isBtnUnderText'
  | 'badgesOptions'
>;

const HeroHalfTestContent = ({
  sectionType,
  unifiedButton,
  unifiedButton2,
  headline,
  text,
  caption,
  captionIcon,
  ratingTitle,
  ratingValue,
  isBtnUnderText,
  badgesOptions,
  visibleOnPageLoad
}: Props) => {
  return (
    <div className={styles.content}>
      <HeroHalfTestHeadlineAndSubtitle
        headline={headline}
        ratingValue={ratingValue}
        ratingTitle={ratingTitle}
      />
      {text && (
        <Typography
          component="div"
          variant="body"
          size="3"
          weight="400"
          noPadding
          className={styles.text}
          color="black-new">
          <CustomPortableText value={text} />
        </Typography>
      )}
      <div className={clsx(styles.buttonsWrapper, isBtnUnderText && styles.isBtnUnderText)}>
        {unifiedButton?.switchButton !== 'noButton' && (
          <UnifiedButton
            unifiedButton={unifiedButton as UnifiedButtonType}
            sectionType={sectionType}
            className={styles.button}
            size={{ xxs: 'medium', l: 'large' }}
            theme="new"
          />
        )}
        {unifiedButton2?.switchButton !== 'noButton' && (
          <UnifiedButton
            unifiedButton={unifiedButton2 as unknown as UnifiedButtonType}
            sectionType={sectionType}
            className={styles.button}
            size={{ xxs: 'medium', l: 'large' }}
            theme="new"
          />
        )}
      </div>
      {caption && (
        <div className={styles.caption}>
          {captionIcon?.asset && (
            <StudioBaseImageV2
              image={captionIcon}
              className={styles.icon}
              eagerLoading={visibleOnPageLoad}
            />
          )}
          <Typography variant="portalCaption" size="1" noPadding color="black-new">
            {caption}
          </Typography>
        </div>
      )}
      <Badges badgesOptions={badgesOptions} visibleOnPageLoad={visibleOnPageLoad} />
    </div>
  );
};
export default HeroHalfTestContent;
